import React, { useState, useEffect } from 'react';
import './Dashboard.css';

const HDashboard = ({product}) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        'https://api.dectwinhotel.com/api/get-all-users'
      );

      if (response.ok) {
        const data = await response.json();
        setUsers(data);
      } else {
        console.error('Failed to fetch users');
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    }

    setLoading(false);
  };

  // ==========================
  // Dashboard Calculations
  // ==========================

  const now = new Date();

  const currentMonth = now.getMonth();
  const currentYear = now.getFullYear();

  const nextMonthDate = new Date(
    currentYear,
    currentMonth + 1,
    1
  );

  const nextMonth = nextMonthDate.getMonth();
  const nextMonthYear = nextMonthDate.getFullYear();

  // Current Month Expiring
const currentMonthExpiring = users.filter((user) => {
  if (!user.subscription_on) return false;

  const endDate = new Date(user.subscription_on);
  endDate.setFullYear(endDate.getFullYear() + 1);

  return (
    endDate.getMonth() === currentMonth &&
    endDate.getFullYear() === currentYear
  );
});

  // Upcoming Month Expiring
  const upcomingMonthExpiring = users.filter((user) => {
  if (!user.subscription_on) return false;

  const endDate = new Date(user.subscription_on);
  endDate.setFullYear(endDate.getFullYear() + 1);

    return (
      endDate.getMonth() === nextMonth &&
      endDate.getFullYear() === nextMonthYear
    );
  });

  // Current Month Purchases
  const currentMonthPurchases = users.filter((user) => {
    if (!user.subscription_on) return false;

    const startDate = new Date(user.subscription_on);

    return (
      startDate.getMonth() === currentMonth &&
      startDate.getFullYear() === currentYear
    );
  });

  const dashboardCards = [
    {
      title: 'Total Users',
      value: users.length,
      icon: 'fa-users',
      className: 'dashboard-primary',
      textClass: 'text-dashboard-primary',
      circleClass: 'circle-primary',
    },
    {
      title: 'Current Month Expiring',
      value: currentMonthExpiring.length,
      icon: 'fa-calendar-xmark',
      className: 'dashboard-danger',
      textClass: 'text-dashboard-danger',
      circleClass: 'circle-danger',
    },
    {
      title: 'Upcoming Month Expiring',
      value: upcomingMonthExpiring.length,
      icon: 'fa-clock',
      className: 'dashboard-warning',
      textClass: 'text-dashboard-warning',
      circleClass: 'circle-warning',
    },
    {
      title: 'Current Month Purchases',
      value: currentMonthPurchases.length,
      icon: 'fa-cart-shopping',
      className: 'dashboard-success',
      textClass: 'text-dashboard-success',
      circleClass: 'circle-success',
    },
  ];

  return (
    <section className='containerfluid py-3'>
      {/* Header */}

      <div className='dashboard-header mb-4'>
        <div>
          <h2 className='dashboard-title'>
            Dashboard Overview
          </h2>

          <p className='dashboard-subtitle'>
            Welcome back, Admin 👋
          </p>
        </div>

        <button
          className='btn btn-dark rounded-pill px-4'
          onClick={fetchUsers}
        >
          Refresh
        </button>
      </div>

      {/* Loading */}

      {loading ? (
        <div className='text-center py-5'>
          <div className='spinner-border text-primary'></div>
        </div>
      ) : (
        <>
          {/* Cards */}

          <div className='row g-3'>
            {dashboardCards.map((card, index) => (
              <div className='col-xl-3 col-md-6 ' key={index}>
                <div
                  className={`dashboard-card shadow-sm ${card.className}`}
                >
                  <div className='d-flex justify-content-between align-items-start'>
                    <div>
                      <p
                        className={`dashboard-card-title ${card.textClass}`}
                      >
                        {card.title}
                      </p>

                      <h1
                        className={`dashboard-card-value ${card.textClass}`}
                      >
                        {card.value}
                      </h1>
                    </div>

                    <div
                      className={`dashboard-icon-wrapper ${card.circleClass}`}
                    >
                      <i
                        className={`fa-solid ${card.icon} dashboard-icon ${card.textClass}`}
                      ></i>
                    </div>
                  </div>

                  <div
                    className={`dashboard-circle ${card.circleClass}`}
                  ></div>
                </div>
              </div>
            ))}
          </div>

          {/* Panels */}

          <div className='row mt-3'>
            {/* Expiring */}

            <div className='col-lg-6 mb-3'>
              <div className='dashboard-panel'>
                <div className='d-flex justify-content-between align-items-center mb-3'>
                  <h5 className='dashboard-panel-title text-danger'>
                    Expiring This Month
                  </h5>

                  <span className='badge bg-danger'>
                    {currentMonthExpiring.length}
                  </span>
                </div>

                {currentMonthExpiring.length > 0 ? (
                  currentMonthExpiring
                    .slice(0, 5)
                    .map((user) => (
                      <div
                        key={user.id}
                        className='dashboard-user-row'
                      >
                        <div>
                          <p className='fw-semibold mb-0'>
                            {user.business_name}
                          </p>

                          <small className='text-muted'>
                            {user.mobile}
                          </small>
                        </div>

                        <div className='text-end'>
                          <small className='text-danger fw-semibold'>
                            {new Date(
  new Date(user.subscription_on).setFullYear(
    new Date(user.subscription_on).getFullYear() + 1
  )
).toLocaleDateString('en-IN')}
                          </small>
                        </div>
                      </div>
                    ))
                ) : (
                  <p className='text-muted mb-0'>
                    No expiring users this month.
                  </p>
                )}
              </div>
            </div>

            {/* Purchases */}

            <div className='col-lg-6 mb-3'>
              <div className='dashboard-panel'>
                <div className='d-flex justify-content-between align-items-center mb-3'>
                  <h5 className='dashboard-panel-title text-success'>
                    New Purchases
                  </h5>

                  <span className='badge bg-success'>
                    {currentMonthPurchases.length}
                  </span>
                </div>

                {currentMonthPurchases.length > 0 ? (
                  currentMonthPurchases
                    .slice(0, 5)
                    .map((user) => (
                      <div
                        key={user.id}
                        className='dashboard-user-row'
                      >
                        <div>
                          <p className='fw-semibold mb-0'>
                            {user.business_name}
                          </p>

                          <small className='text-muted'>
                            {user.mobile}
                          </small>
                        </div>

                        <div className='text-end'>
                          <small className='text-success fw-semibold'>
                            {new Date(
                              user.subscription_on
                            ).toLocaleDateString('en-IN')}
                          </small>
                        </div>
                      </div>
                    ))
                ) : (
                  <p className='text-muted mb-0'>
                    No purchases this month.
                  </p>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </section>
  );
};

export default HDashboard;